import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubmitButtonShared } from '../../general/shared/submit-button-shared';
import { ProgressNavShared } from '../../general/shared/progress-nav-shared';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import { Subscription } from 'rxjs';
import { GenerateShared } from '../../general/shared/generate-shared';
import { ActivityLevelService } from 'src/app/data/repository/generate-repository/activity-level.service';
import { PopupShared } from '../../general/shared/popup-shared';
import { PopupInputModel } from '../../general/popup/popup.component';
import { LoadingShared } from '../../general/shared/loading-shared';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { GenerateDataService } from 'src/app/data/repository/generate-repository/generate-data.service';
import { GenerateModel } from 'src/app/core/model/object/generate-model';

@Component({
  selector: 'app-generate',
  templateUrl: './generate.component.html',
  styleUrls: ['./generate.component.scss'],
})
export class GenerateComponent implements OnInit, OnDestroy {
  type: string;
  dataIsReady = true;
  currentStep = 1;
  buttonTitle = 'مرحله بعد';
  pageNumbers = [];
  showPopup = false;
  popupInputModel: PopupInputModel;
  buttonActivationStatus = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  showLoading = false;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;
  subscription7: Subscription;
  subscription8: Subscription;

  constructor(
    private generateService: GenerateService,
    private submitButtonShared: SubmitButtonShared,
    private progressNavShared: ProgressNavShared,
    public generateShared: GenerateShared,
    private popupShared: PopupShared,
    private route: ActivatedRoute,
    private loadingShared: LoadingShared,
    private diaryAnalytics: DiaryAnalyticsService,
    private generateDataService: GenerateDataService
  ) {
    this.submitButtonShared.activateNextButton(false);
    this.subscription1 = this.generateShared.nextPageObs$.subscribe(
      (clicked) => {
        if (clicked) {
          this.nextPage();
        }
      }
    );
    this.subscription2 =
      this.progressNavShared.progressNavPreStepObs$.subscribe((clicked) => {
        if (clicked) {
          this.previousPage();
        }
      });
    this.subscription3 =
      this.generateShared.generateActivateButtonObs$.subscribe((id) => {
        if (id !== -1) {
          this.buttonActivationStatus[id] = 1;
        }
      });
    this.subscription4 =
      this.generateShared.generateDeactivateButtonObs$.subscribe((id) => {
        if (id !== -1) {
          this.buttonActivationStatus[id] = 0;
        }
      });
    this.subscription5 = this.popupShared.closePopupObs$.subscribe((close) => {
      if (close) {
        this.showPopup = false;
      }
    });
    this.subscription6 = this.generateShared.showPopupObs$.subscribe((show) => {
      if (show) {
        if (this.pageNumbers[this.currentStep - 1] === 2) {
          this.popupInputModel = new PopupInputModel(
            'برنامه غذایی',
            'با توجه به وزن و میزان فعالیت برای شما برنامه غذایی نداریم',
            'باشه'
          );
          this.showPopup = true;
        }
        if (this.pageNumbers[this.currentStep - 1] === 6) {
          this.popupInputModel = new PopupInputModel(
            'درجه سختی',
            'با توجه به اطلاعات وارد شده نمی‌توانیم این گزینه را به شما بدهیم',
            'باشه'
          );
          this.showPopup = true;
        }
      }
    });
    this.subscription7 = this.loadingShared.showLoadingObs$.subscribe(
      (show) => {
        if (show) {
          setTimeout(() => {
            this.showLoading = true;
          }, 0);
        }
      }
    );
    this.subscription8 = this.loadingShared.hideLoadingObs$.subscribe(
      (hide) => {
        if (hide) {
          setTimeout(() => {
            this.showLoading = false;
          }, 0);
        }
      }
    );
  }

  ngOnInit() {
    this.diaryAnalytics.analyticDiaryGetDietStarted();
    this.generateService.isDetail = false;
    this.type = this.route.snapshot.paramMap.get('type');
    if (!this.generateShared.selectedDietType) {
      this.generateService.backToMenu();
      return;
    }
    if (!this.type) {
      this.submitButtonShared.activateNextButton(true);
      this.pageNumbers = [1, 2, 7];
    } else if (
      this.generateShared.selectedDietType &&
      this.generateShared.selectedDietType.type === 'daily'
    ) {
      this.generateShared.goal = this.type;
      switch (this.type) {
        case 'weightLoss': {
          this.submitButtonShared.activateNextButton(false);
          // this.pageNumbers = [1, 2, 3, 5, 6, 7];
          this.pageNumbers = [10, 1, 2, 3, 4, 5, 6, 7];
          break;
        }
        case 'weightFix': {
          this.submitButtonShared.activateNextButton(false);
          // this.pageNumbers = [1, 2, 3, 5, 7];
          this.pageNumbers = [10, 1, 2, 3, 4, 5, 7];
          break;
        }
      }
    } else {
      this.generateShared.goal = this.type;
      switch (this.type) {
        case 'weightLoss': {
          this.submitButtonShared.activateNextButton(true);
          // this.pageNumbers = [1, 2, 3, 5, 6, 7];
          this.pageNumbers = [1, 2, 3, 4, 5, 6, 7];
          break;
        }
        case 'weightGain': {
          this.submitButtonShared.activateNextButton(true);
          // this.pageNumbers = [1, 2, 3, 5, 6, 7];
          this.pageNumbers = [1, 2, 3, 4, 5, 6, 7];
          break;
        }
        case 'weightFix': {
          this.submitButtonShared.activateNextButton(true);
          // this.pageNumbers = [1, 2, 3, 5, 7];
          this.pageNumbers = [1, 2, 3, 4, 5, 7];
          break;
        }
        case 'pregnancy': {
          this.submitButtonShared.activateNextButton(false);
          // this.pageNumbers = [8, 1, 2, 3, 5, 7];
          this.pageNumbers = [8, 1, 2, 3, 4, 5, 7];
          break;
        }
        case 'breastfeeding': {
          this.submitButtonShared.activateNextButton(false);
          // this.pageNumbers = [9, 1, 2, 3, 5, 7];
          this.pageNumbers = [9, 1, 2, 3, 4, 5, 7];
          break;
        }
      }
    }
    // this.dataIsReady = true;
    setTimeout(() => {
      document.getElementById(
        this.pageNumbers[0].toString() + 'Page'
      ).style.right = '0';
      this.progressNavShared.progressNavShowBackButton();
    }, 100);
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
    this.subscription6.unsubscribe();
    this.subscription7.unsubscribe();
    this.subscription8.unsubscribe();
  }

  nextPage() {
    if (this.currentStep < this.pageNumbers.length) {
      if (this.pageNumbers[this.currentStep] === 1) {
        this.submitButtonShared.activateNextButton(true);
      } else if (this.pageNumbers[this.currentStep] === 2) {
        this.submitButtonShared.activateNextButton(false);
      } else if (this.pageNumbers[this.currentStep] === 3) {
        this.submitButtonShared.animateDownButton();
      } else if (
        this.pageNumbers[this.currentStep] === 4 ||
        this.pageNumbers[this.currentStep] === 5
      ) {
        this.submitButtonShared.activateNextButton(true);
        this.submitButtonShared.animateUpButton();
      } else if (this.pageNumbers[this.currentStep] === 6) {
        this.submitButtonShared.animateDownButton();
        this.submitButtonShared.activateNextButton(false);
      } else if (this.pageNumbers[this.currentStep] === 7) {
        this.submitButtonShared.activateNextButton(true);
        this.submitButtonShared.animateUpButton();
      } else if (this.pageNumbers[this.currentStep] === 10) {
        this.submitButtonShared.activateNextButton(false);
        this.submitButtonShared.animateUpButton();
      }
      if (
        this.buttonActivationStatus[this.pageNumbers[this.currentStep] - 1] ===
        1
      ) {
        this.submitButtonShared.activateNextButton(true);
      }
      this.animatePages(
        this.pageNumbers[this.currentStep].toString() + 'Page',
        this.pageNumbers[this.currentStep - 1].toString() + 'Page',
        true
      );
      this.currentStep++;
    } else {
      this.submitButtonShared.animateDownButton();
      this.saveGenerate();
      setTimeout(() => {
        this.generateService.goToOverview();
      }, 300);
    }
  }

  previousPage() {
    if (this.pageNumbers[this.currentStep - 2] === 2) {
      this.submitButtonShared.animateUpButton();
    } else if (this.pageNumbers[this.currentStep - 2] === 3) {
      this.submitButtonShared.animateDownButton();
    } else if (this.pageNumbers[this.currentStep - 2] === 5) {
      this.submitButtonShared.animateUpButton();
    } else if (this.pageNumbers[this.currentStep - 2] === 6) {
      this.submitButtonShared.animateDownButton();
    }
    if (this.currentStep > 1) {
      this.submitButtonShared.activateNextButton(true);
      this.animatePages(
        this.pageNumbers[this.currentStep - 2].toString() + 'Page',
        this.pageNumbers[this.currentStep - 1].toString() + 'Page',
        false
      );
      this.currentStep--;
    } else {
      this.generateShared.setDiseases([]);
      this.generateShared.setHatedFoods([]);
      this.generateShared.setFastingDays([]);
      this.generateService.back();
    }
  }

  saveGenerate() {
    const generate = new GenerateModel(
      this.generateShared.selectedDietType,
      this.generateShared.weight,
      this.generateShared.startDay,
      this.generateShared.startDays,
      this.generateShared.goal,
      this.generateShared.getCalories(),
      this.generateShared.difficulty,
      this.generateShared.calorie,
      this.generateShared.activityLevel,
      this.generateShared.specialTypeStartDate
        ? this.generateShared.specialTypeStartDate.getTime()
        : 0,
      this.generateShared.isVegeterian,
      this.generateShared.getDiseases(),
      this.generateShared.getHatedFoods(),
      this.generateShared.getFastingDays()
    );
    this.generateDataService.saveGenerate(generate);
  }

  animatePages(enter: string, leave: string, isForward: boolean) {
    if (isForward) {
      document.getElementById(leave).style.right = '-100%';
    } else {
      document.getElementById(leave).style.right = '100%';
    }
    document.getElementById(enter).style.right = '0%';
  }
}
